import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import { GetMediaBannersResponse, GetMediaBannerByIdResponse, PostMediaBannerResponse } from '../response/banner';
import { CreateBannerRequest, UpdateBannerRequest } from '../request/banner';

export class BannerService {
  static getBanners(params?: QueryParams) {
    return apiClient.get<GetMediaBannersResponse>(buildApiUrl('/api/v1/media/banner'), params);
  }

  static postBanner(data: CreateBannerRequest) {
    return apiClient.createWithFile<PostMediaBannerResponse>(buildApiUrl('/api/v1/media/banner'), data);
  }

  static getBannerById(id: string) {
    const url = buildApiUrl('/api/v1/media/banner/:id', { id });
    return apiClient.get<GetMediaBannerByIdResponse>(url, undefined);
  }

  static deleteBanner(id: string) {
    const url = buildApiUrl('/api/v1/media/banner/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }

  static updateBanner(id: string, data: UpdateBannerRequest) {
    const url = buildApiUrl('/api/v1/media/banner/:id', { id });
    return apiClient.updateWithFile<void>(url, data);
  }
}
